<template>
  <div class="commom-page">
    <!-- 头部公共 -->
    <div class="common-header">
      <div class="pc_home_header flex-h">
        <div class="pc_home_header_left flex-h">
          <div
            style="color: #ed2700"
            @click="goLogin"
            v-if="isTouris"
            class="header_left_child"
          >
            亲,请先登陆
          </div>
          <div
            v-else
            class="show-storename header_left_child"
            @mouseover="showEwm(1)"
            @mouseout="showEwm(0)"
          >
            <div>
              欢迎 <span style="color: #ed2700">{{ name }}</span>
            </div>
            <div
              class="exchange-discount"
              v-show="luserAccounts.length > 0 && curNav == 0 && exchange == 1"
              @mouseover="showEwm(1)"
              @mouseout="showEwm(0)"
            >
              <div
                v-for="(item, index) in luserAccounts"
                :key="index"
                class="line-clamp-1"
                @click="exchangeDiscount(item)"
              >
                <van-icon
                  name="success"
                  color="#1989fa"
                  v-show="item.selected == 1"
                />
                <span :class="{ 'discount-active': item.selected == 1 }">{{
                  item.customerName
                }}</span>
              </div>
              <div class="exchange-btn">切换店铺</div>
            </div>
          </div>
          <div v-if="isTouris" @click="goRegister" class="header_left_child">
            免费注册
          </div>
          <div
            v-else
            @click="goCenter"
            :class="{ active: curNav == 13 }"
            class="header_left_child"
          >
            个人中心
          </div>
          <!-- <div @click="loginOut" v-else>退出登陆</div> -->
          <!-- <div v-if="this.name != ''" @click="enterPassword">修改密码</div> -->
        </div>
        <div class="pc_home_header_right flex-1 flex-h">
          <div @click="enterSearch" class="flex-h">
            <van-icon name="search" color="#333" size="16" />搜索
          </div>
          <div v-for="(item, index) in navList" :key="index">
            <span
              :class="{ active: curNav == index }"
              @click="changeNav(index)"
              >{{ item }}</span
            >
          </div>
          <div class="common-width">
            金额:<span style="color: #ff0000; font-weight: bold">{{
              totalMoney
            }}</span>
          </div>
          <div class="common-width">
            品种数:<span style="color: #ff0000; font-weight: bold">{{
              totalNum
            }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="pc_home_search">
        <div class="search-content">
          <input
            type="text"
            placeholder="按条码后6位,编码,品名,品牌等"
            v-model="searchName"
          />
          <div class="search-btn" @click="searchFood">搜索</div>
          <div class="show-cart" @click="changeNav(2)">
            <div class="cart-icon">
              <div class="cart-total-dot" v-if="totalNum > 0">
                {{ totalNum }}
              </div>
              <van-icon name="cart-o" size="20px" color="#FE8A03 " />
            </div>
            <span class="cart-name">我的购物车</span>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 底部公共 -->
    <!-- <div
      class="common-footer"
      v-if="curNav < 3 || curNav == 11"
      :class="{ 'has-recordNo': curNav == 0 }"
    >
      <div class="footer-btn-home flex-box-v" @click="goHome">
        <img src="@/assets/bg_home_page_normal.png" alt="" />
        <div>首页</div>
      </div>
      <div class="footer-btn-service flex-box-v" @click="goCall">
        <img src="@/assets/bg_customer_service_normal.png" alt="" />
        <div>客服</div>
      </div>
      <div
        class="footer-money-nun flex-box-v"
        :class="{ 'flex-1': curNav !== 2 || totalMoney == 0 }"
      >
        <div style="font-size: 17px">
          金额：<span style="color: #ff2a00">{{ totalMoney }}</span>
        </div>
        <div>品种数：{{ totalNum }}</div>
      </div>
      <div class="chooseAll flex-h flex-1" v-if="curNav == 2 && totalMoney > 0">
        <van-checkbox
          v-model="checkedAll"
          icon-size="24px"
          checked-color="#FFA336"
          @click="changeAll"
          >全选</van-checkbox
        >
        <div
          class="chooseAll-del"
          @click="delAll"
          v-if="checkedAll && totalMoney > 0"
        >
          清空购物车
        </div>
      </div>
      <div class="footer-btn-cart" @click="goCart" v-if="curNav !== 2">
        <img src="@/assets/bg_shopping_cart_click.png" alt="" />
      </div>
      <div v-else class="footer-btn-discount" @click="goDiscount">去结算</div>
    </div> -->
    <div class="cart-footer" v-if="curNav == 2">
      <div class="chooseAll flex-h flex-1">
        <van-checkbox
          v-model="checkedAll"
          icon-size="24px"
          checked-color="#FFA336"
          @click="changeAll"
          >全选</van-checkbox
        >
        <div class="chooseAll-del" @click="delAll">清空购物车</div>
      </div>
      <div class="common-width">
        金额:<span style="color: #ff4400; font-weight: bold; font-size: 20px"
          ><span style="font-size: 10px">¥</span>{{ totalMoney }}</span
        >
      </div>
      <div style="margin: 0 20px" class="common-width">
        品种数:<span
          style="color: #ff4400; font-weight: bold; font-size: 20px"
          >{{ totalNum }}</span
        >
      </div>
      <div class="footer-btn-discount" @click="goDiscount">结算</div>
    </div>
    <!-- 备案号 -->
    <div
      v-if="recordNo && curNav == 0"
      class="all-page-recordNo"
      @click="enterRecordNo"
    >
      备案号:{{ recordNo }}
    </div>
    <!-- 展示商家电话 -->
    <van-popup v-model="show" class="phone-pop">
      <div>商家电话:{{ phone }}</div>
      <div @click="show = false">关闭</div>
    </van-popup>
  </div>
</template>

<script>
import { getTotal, exchangeDiscount } from "@/api/api";
export default {
  data() {
    return {
      navList: [
        "首页",
        "分类",
        "购物车",
        // "个人中心",
        "常购清单",
        "积分兑换",
        "签到红包",
        "再来一单",
        "我的关注",
        "联系客服",
      ],
      totalMoney: 0,
      totalNum: 0,
      name: "", //客户名称
      searchName: "", //搜索内容
      show: false, //展示商家电话
      phone: "",
      checkedAll: true,
      recordNo: "", //备案号
      isTouris: false, //判断是否为游客
      exchange: 0, //显示和隐藏更换账号菜单
      countIndex: -1, //要切换的账号数组下标
    };
  },
  props: {
    curNav: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    //多账号
    luserAccounts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    if (sessionStorage.getItem("storeBase")) {
      var info = JSON.parse(sessionStorage.getItem("storeBase"));
      this.phone = info.phone;
      this.name = sessionStorage.getItem("customer") || "";
      this.recordNo = info.recordNo || "";
    }
    if (sessionStorage.getItem("uni") == "ALL") {
      this.isTouris = true;
    }
    if (this.curNav > 2) {
      this.showTotal();
    }
  },
  activated() {
    if (sessionStorage.getItem("storeBase")) {
      var info = JSON.parse(sessionStorage.getItem("storeBase"));
      this.phone = info.phone;
      this.name = sessionStorage.getItem("customer") || "";
      this.recordNo = info.recordNo || "";
    }
    if (sessionStorage.getItem("uni") == "ALL" && !this.isTouris) {
      this.isTouris = true;
    }
  },
  methods: {
    //显示切换账号
    showEwm(type) {
      this.exchange = type;
    },
    //切换账号
    async exchangeDiscount(item) {
      let str = {
        type: 1,
        uni: item.uni,
      };
      const res = await exchangeDiscount(str);
      console.log(res);
      if (res.code == 200) {
        this.exchange = 0;
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("uni", res.data.uni);
        sessionStorage.setItem("customer", res.data.name);
        location.reload();
      } else {
        this.$dialog
          .alert({
            message: res.error,
          })
          .then(() => {});
      }
    },
    enterPassword() {
      this.$router.push({
        path: "/password",
      });
    },
    goCenter() {
      if (this.isTouris) {
        this.$dialog
          .confirm({
            title: "您还未登陆",
            message: "游客模式无法查看价格和详情,是否去登陆？",
          })
          .then(() => {
            this.$router.push({
              path: "/login",
            });
          })
          .catch(() => {});
        return;
      }
      this.$router.push({
        path: "/center",
      });
    },
    enterRecordNo() {
      window.open("https://beian.miit.gov.cn");
    },
    enterSearch() {
      this.$router.push({
        path: "/search",
      });
    },
    changeNav(index) {
      switch (index) {
        case 0:
          this.$router.replace({
            path: "/home",
          });
          break;
        case 1:
          this.$router.push({
            path: "/classfiy",
          });
          break;
        case 2:
          if (this.isTouris) {
            this.$dialog
              .confirm({
                title: "您还未登陆",
                message: "游客模式无法查看价格和详情,是否去登陆？",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                });
              })
              .catch(() => {});
            return;
          }
          this.$router.push({
            path: "/cart",
          });
          break;
        // case 3:
        //   this.$router.push({
        //     path: "/center",
        //   });
        //   break;
        case 3:
          this.$store.commit("setIsSearch", true);
          this.$router.push({
            path: "/classfiy",
            query: {
              searchName: "xsls",
            },
          });
          break;
        case 4:
          if (this.isTouris) {
            this.$dialog
              .confirm({
                title: "您还未登陆",
                message: "游客模式无法查看价格和详情,是否去登陆？",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                });
              })
              .catch(() => {});
            return;
          }
          this.$router.push({
            path: "/integral",
          });
          break;
        case 5:
          if (this.isTouris) {
            this.$dialog
              .confirm({
                title: "您还未登陆",
                message: "游客模式无法查看价格和详情,是否去登陆？",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                });
              })
              .catch(() => {});
            return;
          }
          this.$router.push({
            path: "/sign",
          });
          break;
        case 6:
          if (this.isTouris) {
            this.$dialog
              .confirm({
                title: "您还未登陆",
                message: "游客模式无法查看价格和详情,是否去登陆？",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                });
              })
              .catch(() => {});
            return;
          }
          this.$router.push({
            path: "/order-index",
            query: {
              type: 0,
            },
          });
          break;
        case 7:
          this.$store.commit("setIsSearch", true);
          this.$router.push({
            path: "/classfiy",
            query: {
              searchName: "follow",
            },
          });
          break;
        case 8:
          this.goCall();
          break;
      }
    },
    changeAll() {
      this.$emit("changeAll", this.checkedAll);
    },
    //获取购物车数据汇总
    async showTotal() {
      const res = await getTotal({ onceAgain: 0 });
      console.log(res);
      if (res.code == 200) {
        this.totalMoney = parseFloat(res.data.amount).toFixed(2);
        this.totalNum = res.data.num;
        this.$store.commit("setCartTotal", res.data.num);
      } else {
        if (res.code !== 201) {
          this.$toast(res.error);
        }
        this.$store.commit("setCartTotal", 0);
        this.totalMoney = 0;
        this.totalNum = 0;
      }
    },
    //去登陆
    goLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    //搜索产品
    searchFood() {
      if (this.searchName == "" && this.curNav !== 5) return;
      if (this.curNav !== 1 && this.curNav !== 5) {
        this.$store.commit("setIsSearch", true);
        this.$router.push({
          path: "/classfiy",
          query: {
            searchName: this.searchName,
          },
        });
      } else {
        this.$emit("searchFood", this.searchName);
      }
    },
    //回到购物车
    goCart() {
      this.$router.push({
        path: "/cart",
      });
    },
    //回到首页
    goHome() {
      this.$router.replace({
        path: "/home",
      });
    },
    //展示商家电话弹窗
    goCall() {
      this.show = true;
    },
    //退出登陆
    loginOut() {
      const that = this;
      this.$dialog
        .confirm({
          message: "确定退出登陆吗?",
        })
        .then(() => {
          that.name = "";
          //清除所有临时缓存
          // window.sessionStorage.clear();
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("storeToken");
          sessionStorage.removeItem("customer");
          that.$router.push({
            path: "/login",
          });
        })
        .catch(() => {});
    },
    //去结算
    goDiscount() {
      this.$emit("goDiscount");
    },
    //清空购物车
    delAll() {
      this.$dialog
        .confirm({
          message: "确认要清空购物车数据吗?",
        })
        .then(() => {
          this.$emit("delAll");
        })
        .catch(() => {});
    },
    goRegister() {
      this.$router.push({
        path: "/register",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.commom-page {
  .common-width {
    min-width: 90px;
    text-align: left;
  }
  .active {
    color: #ed2700;
  }
  .common-header {
    position: fixed;
    z-index: 10;
    left: 0;
    right: 0;
    top: 0;
    background-color: #fff;
    .pc_home_header {
      background: #e3e4e5;
      justify-content: space-between;
      padding: 0 8%;
      height: 40px;
      position: relative;
      .pc_home_header_left {
        .header_left_child {
          margin: 0 10px;
          cursor: pointer;
        }
        .show-storename {
          position: relative;
          height: 40px;
          line-height: 40px;
          .exchange-discount {
            position: absolute;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            left: 50%;
            margin-left: -90px;
            width: 180px;
            border: 1px solid #eee;
            z-index: 21 !important;
            background-color: #fff;
            border-radius: 5px;
            font-size: 14px;
            color: #000;
            &::-webkit-scrollbar {
              display: none !important;
            }
            div {
              cursor: pointer;
            }
            .line-clamp-1 {
              font-size: 13px;
              border-bottom: 1px solid #eee;
              .discount-active {
                color: #1989fa;
              }
            }
            .exchange-btn {
              background-color: #f34f28;
              color: #fff;
            }
          }
        }
      }
      .pc_home_header_right {
        flex: 1;
        justify-content: flex-end;
        div {
          margin: 0 10px;
          cursor: pointer;
          .active {
            color: #ed2700;
          }
        }
      }
    }
    .pc_home_search {
      margin: 16px 0 10px 0;
      .search-content {
        position: relative;
        display: flex;
        width: 1050px;
        margin: 0 auto;
        input {
          height: 42px;
          border: none;
          background: #ffffff;
          border: 1px solid #ff5200;
          border-radius: 18px;
          padding: 0 100px 0 20px;
          flex: 1;
        }
        .search-btn {
          position: absolute;
          right: 134px;
          top: 50%;
          margin-top: -18px;
          background: linear-gradient(135deg, #ff5400, #ff8e00);
          border-radius: 18px;
          width: 80px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 15px;
          font-family: "Source Han Serif CN";
          font-weight: bold;
          color: #ffffff;
          cursor: pointer;
        }
        .show-cart {
          width: 118px;
          height: 42px;
          border: 1px solid #fe8a03;
          border-radius: 18px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .cart-icon {
            position: relative;
            .cart-total-dot {
              position: absolute;
              top: -8px;
              right: -14px;
              line-height: 1;
              background: #fe8a03;
              border-radius: 50%;
              text-align: center;
              padding: 2px;
              min-width: 12px;
              color: #fff;
              font-size: 10px;
              z-index: 10;
            }
            >>> .van-icon {
              font-weight: bold;
            }
          }

          .cart-name {
            margin-left: 20px;
            font-size: 10px;
            font-family: "Source Han Serif CN";
            font-weight: bold;
            color: #fe8a03;
          }
        }
      }
    }
  }
  .all-page-recordNo {
    height: 20px;
    position: fixed;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
    cursor: pointer;
  }
  .has-recordNo {
    bottom: 20px !important;
  }
  .cart-footer {
    position: fixed;
    z-index: 10;
    left: 15%;
    right: 15%;
    bottom: 0;
    background-color: #e5e5e5;
    display: flex;
    height: 40px;
    padding: 0 0 0 10px;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #eee;
    .chooseAll {
      .chooseAll-del {
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          color: #ff5200;
        }
      }
    }
    .footer-btn-discount {
      width: 150px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      letter-spacing: 4px;
      color: #fff;
      font-weight: bold;
      background-color: #ff5200;
      cursor: pointer;
    }
  }
  .common-footer {
    position: fixed;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    height: 60px;
    padding: 0 0 0 10px;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-top: 1px solid #eee;
    .footer-btn-discount {
      width: 200px;
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      letter-spacing: 4px;
      color: #fff;
      font-weight: bold;
      background-color: #ff5200;
    }
    .footer-btn-home {
      align-items: center;
      font-size: 13px;
      cursor: pointer;
      img {
        height: 21px;
        width: 22px;
        margin-bottom: 4px;
      }
    }

    .footer-btn-service {
      margin: 0 20px;
      font-size: 13px;
      align-items: center;
      cursor: pointer;
      img {
        height: 21px;
        width: 23px;
        margin-bottom: 4px;
      }
    }
    .chooseAll {
      margin-left: 20px;
      .chooseAll-del {
        height: 36px;
        line-height: 36px;
        color: #fff;
        background-color: #ff5200;
        border-radius: 10px;
        width: 100px;
        margin-left: 20px;
      }
    }
    .footer-btn-cart img {
      height: 52px;
      width: 52px;
      cursor: pointer;
    }
    .footer-money-nun {
      font-size: 13px;
      color: #666;
      text-align: left;
    }
  }
  .phone-pop {
    padding: 20px;
    border-radius: 8px;
    :nth-child(1) {
      font-size: 20px;
    }
    :nth-child(2) {
      margin: 20px auto 0 auto;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 8px;
      color: #fff;
      background-color: #ff5200;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common-header.vue